import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import { BaseIcon } from "../base-icon";
export var CrossIcon = function(_param) /*#__PURE__*/ {
    var color = _param.color, _size = _param.size, size = _size === void 0 ? 13 : _size, props = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    return _jsx(BaseIcon, _object_spread_props(_object_spread({}, props), {
        color: color,
        height: size,
        width: size,
        children: size === 13 ? /*#__PURE__*/ _jsx("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M12.78 1.28A.75.75 0 0 0 11.72.22L6.5 5.44 1.28.22A.75.75 0 1 0 .22 1.28L5.44 6.5.22 11.72a.75.75 0 1 0 1.06 1.06L6.5 7.56l5.22 5.22a.75.75 0 1 0 1.06-1.06L7.56 6.5l5.22-5.22Z",
            clipRule: "evenodd"
        }) : size === 16 ? /*#__PURE__*/ _jsx("path", {
            fill: "currentColor",
            d: "M.47 14.47a.75.75 0 0 0 1.06 1.06L8 9.06l6.47 6.47a.75.75 0 0 0 1.06-1.06L9.06 8l6.47-6.47A.75.75 0 1 0 14.47.47L8 6.94 1.53.47A.75.75 0 1 0 .47 1.53L6.94 8 .47 14.47Z"
        }) : /*#__PURE__*/ _jsx("path", {
            fill: "currentColor",
            d: "M.47 22.47a.75.75 0 1 0 1.06 1.06L12 13.06l10.47 10.47a.75.75 0 1 0 1.06-1.06L13.06 12 23.53 1.53A.75.75 0 0 0 22.47.47L12 10.94 1.53.47A.75.75 0 0 0 .47 1.53L10.94 12 .47 22.47Z"
        })
    }));
};
